/**
 * Follow api structure.
 *
 * BasePath is "utilisateurs/".
 */
export const apiUtilisateursBasePath = '/utilisateurs';

// TblUtilisateur
export const utilisateursSubPath = 'utilisateurs';
export const utilisateursUtilisateursPath = `${apiUtilisateursBasePath}/${utilisateursSubPath}/`;
export const utilisateursBasePath = 'utilisateurs';
export const utilisateursListePath = 'utilisateurs';

export const antennesListePath = 'antennes';
// TblGroupesTravail
export const groupesTravailSubPath = 'groupes_travail';
export const utilisateursGroupesTravailPath = `${apiUtilisateursBasePath}/${groupesTravailSubPath}/`;
